export const TEXTS = {
    CHANGE_PLAN: "Change Plan",
    REMOVE: "Remove",
    ADD: "Add",
};

export const ACCESSIBLITY_TEXTS = {
    ONE_SUBSCRIPTION: "Plan Name: {0}",
    COST: "Price: {0} rupees",
    COST_WITH_DISCOUNT: "Base Price: {0} rupees. Final Price after discount: {1} rupees",
    PLAN_BENEFITS: "Swiggy One benefits on this order are: ",
};

export const PRE_CONFIGURED_FILLERS = {
    TOTAL_DISCOUNT: "total_discount",
    SUB_DISCOUNT: "sub_discount",
};

export const SUPER_V3_RENDERING_TYPES = {
    BENEFITS: "SUPER_V3_BENEFITS",
    NUDGE: "SUPER_V3_NUDGE",
};

export const TITLE_BOLD = {
    OPEN: "{{",
    CLOSE: "}}",
};

export const SELECTED_PLAN_MODE = {
    ADD: "ADD",
    REMOVE: "REMOVE",
};

export const DELIVERY_TEXT_COUNTER_SEPERATORS = {
    START: "[[",
    END: "]]",
};

export const SCREEN_READER_TEXT_FOR_DELIVERY_COUNTER = "You have {0} {1} {2}";
export const SCREEN_READER_TEXT_FOR_DELIVERY_COUNTER_MWEB = "You have {0} count as {1}";

export const SWIGGY_ONE_ICONS_HW = {
    ONE: {
        height: "15px",
        width: "44px",
    },
    ONE_LITE: {
        height: "18px",
        width: "78px",
    },
};

export const SWIGGY_ONE_ICONS_HW_SMALL = {
    ONE: {
        height: "11px",
        width: "33px",
    },
    ONE_LITE: {
        height: "11px",
        width: "64px",
    },
};

// Lifetime Savings constants
export const LIFETIME_SAVINGS_NUDGE_LIMIT = 3;
const LIFETIME_SAVINGS_PREFIX = "lifetime_savings";
const createStorageKey = (suffix: string) => `${LIFETIME_SAVINGS_PREFIX}_${suffix}`;

export const STORAGE_KEYS = {
    LIFETIME_SAVINGS_NUDGE_MILESTONE: createStorageKey("milestone"),
    LIFETIME_SAVINGS_FREQUENCY_ACTIVE: createStorageKey("frequency_active"),
    LIFETIME_SAVINGS_FREQUENCY_EXPIRED: createStorageKey("frequency_expired"),
    LIFETIME_SAVINGS_NUDGE_SESSION_ID: createStorageKey("nudge_session_id"),
};

export const DEFAULT_SESSION_VALUE = JSON.stringify({ frequency: 0, sessionId: "" });

export const DELIVERY_TAG_COLORS = {
    LOW: {
        pillBgColor: "highlight_Sub",
        textColor: "highlight",
    },
    HIGH: {
        pillBgColor: "positive_Sub",
        textColor: "positive",
    },
};

export const ONE_WIDGET_PRE_TOOLTIP_CAP_STORAGE = "one_widget_pre_tooltip_cap_storage";

export const CURLY_BRACES = {
    OPEN: "{{",
    CLOSE: "}}",
};

export const STRIKE_TAG = {
    OPEN: "<s>",
    CLOSE: "</s>",
};

export const PRICE_WITH_SYMBOL = "₹ {0}";
